import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { SCHOOL_FEATURE_KEY } from './keys';
import { schoolReducer } from './reducers/school.reducer';
import { SchoolEffects } from './effects/school.effects';

export const schoolStoreProviders = [provideState(SCHOOL_FEATURE_KEY, schoolReducer), provideEffects(SchoolEffects)];

export { SchoolFacade } from './facades/school.facade';
export { schoolCleanup } from './guards/cleanup.guard';
